import React from 'react'
import './styles/HeaderImage.scss'

const HeaderImage = ({ image, text, alt }) => {
  return (
    <div className='HeaderImage'>
      <div className='image'>
        <picture>
          <source media="(min-width:700px)" srcSet={image.desktop} />
          <img src={image.mobile} alt={alt} style={{ width: '100%' }} />
        </picture>
      </div>
      {text && <div className='title'>
        <h1>{text}</h1>
      </div>
      }
    </div>
  )
}


export default HeaderImage
